import { sortDevices, allTemplateNonConformities, expandReference, unique, deviceSubstitutionStatus  } from './utils'; 

/**
 * offerTableData is a function that takes customer products data and returns an array of objects with keys corresponding values, and additional metadata for the table.
 * The function takes the customer products data and returns an array of objects with the following keys:
 * #offers
 *      - _id: the id of the customer product
 *      - nonConformity: the non-conformity of the customer product
 *      - customerProduct: the label of the customer product
 *      - pricelistCode: the price list code of the customer product
 *      - law: the law of the customer product
 *      - lawLabel: the label of the law of the customer product
 *      - description: the description of the customer product
 *      - location: the location of the customer product
 *      - quantity: the quantity of the customer product
 *      - unitPrice: the unit price of the customer product
 *      - discountedUnitPrice: the discounted unit price of the customer product
 *      - priceToClient: the price to the client of the customer product
 *      - discount: the discount of the customer product
 *      - supplierPrice: the supplier price of the customer product
 *      - totalCost: the total cost of the customer product
 *      - margin: the margin of the customer product
 *      - profit: the profit of the customer product
 *      - unitProfit: the unit profit of the customer product
 *      - allowZero: whether to allow zero quantities of the customer product
 *      - labourProduct: whether the customer product is a labour product
 */
export const offerTableData = (data) => {
    //console.log("aushdiwuehdewiuh", data)
    const customerProducts = data
    const sortDevicesBy = "Posizione"
    const customerProductDoc = (cP) => {
        const {
            _id,
            nonConformity,
            customerProduct,
            pricelistCode,
            law,
            lawLabel,
            description,
            location,
            quantity,
            unitPrice,
            discountedUnitPrice,
            priceToClient,
            discount,
            supplierPrice,
            totalCost,
            margin,
            profit,
            unitProfit,
            allowZero,
            labourProduct
        } = cP
        
        const doc = {
            _id, nonConformity, labourProduct, allowZero, discountedUnitPrice, customerProduct, pricelistCode, law, lawLabel, description, location, quantity, unitPrice, priceToClient, discount, supplierPrice, totalCost, margin, profit, unitProfit,
        }
        return doc

    }
    const tableDataArray = !customerProducts ? [] : customerProducts
    ?.map?.((item => {
        const array =  [  
            [{Header:"ID", accessor:"_id", value: customerProductDoc(item)?._id,},], 
            [{Header:"NON CONFORMITA'", accessor:"nonConformity", value: customerProductDoc(item)?.nonConformity}], 
            [{Header:"PRODOTTO", accessor:"customerProduct", value: customerProductDoc(item)?.customerProduct}], 
            [{Header:"COD.", accessor:"pricelistCode", value: customerProductDoc(item)?.pricelistCode, order: 1}],
            [{Header: "NORMATIVA DI RIFERIMENTO PER L'ADEMPIMENTO AGLI OBBLIGHI DEI PRESIDI ATTREZZATURE E SISTEMI", accessor:"law", value: customerProductDoc(item)?.law, minWidth:50, valueType: "RICHEDITOR"}],
            [{Header: "NORMATIVA DI RIFERIMENTO PER L'ADEMPIMENTO AGLI OBBLIGHI DEI PRESIDI ATTREZZATURE E SISTEMI", accessor:"lawLabel", value: customerProductDoc(item)?.lawLabel, minWidth:50}],
            [{Header: "DESCRIZIONE", accessor:"description", value: customerProductDoc(item)?.description, minWidth:70, valueType: "RICHEDITOR"}],
            [{Header: "UBICAZIONE", accessor:"location", value: customerProductDoc(item)?.location}],
            [{Header: "Q.TA’", accessor:"quantity", value: customerProductDoc(item)?.quantity,  valueType: "TWODECIMALS", labourProduct: customerProductDoc(item)?.labourProduct}],
            [{Header: "PREZZO CAD.", accessor:"unitPrice", value: +customerProductDoc(item)?.unitPrice, valueType: "CURRENCY"}],
            [{Header: "SCONTO %", accessor:"discount", value: +customerProductDoc(item)?.discount, valueType: "PERCENTAGE"}],
            [{Header: "PREZZO CAD. SCONTATO", accessor:"discountedUnitPrice", value: +customerProductDoc(item)?.discountedUnitPrice, valueType: "CURRENCY"}],
            [{Header: "TOTALE", accessor:"priceToClient", value: +customerProductDoc(item)?.priceToClient, valueType: "CURRENCY"}],
            [{Header: "PREZZO FORNITORE", accessor:"supplierPrice", value: +customerProductDoc(item)?.supplierPrice, valueType: "CURRENCY",isCost:true}],
            [{Header: "TOTALE COSTO", accessor:"totalCost", value: +customerProductDoc(item)?.totalCost, valueType: "CURRENCY", isCost:true}],
            [{Header: "MARGINE", accessor:"margin", value: +customerProductDoc(item)?.margin, valueType: "PERCENTAGE",isCost:true}],
            [{Header: "PROFITTO", accessor:"profit", value: +customerProductDoc(item)?.profit, valueType: "CURRENCY",isCost:true}],
            [{Header: "PROFITTO CAD.", accessor:"unitProfit", value: +customerProductDoc(item)?.unitProfit, valueType: "CURRENCY",isCost:true}],
            [{Header:"ZERO", accessor:"allowZero", value: customerProductDoc(item)?.allowZero}], 
            [{Header:"LABOUR PRODUCT", accessor:"labourProduct", value: customerProductDoc(item)?.labourProduct}], 
        ] 
        return array
    })) 

    return tableDataArray
}